import { defineMessages } from "react-intl";

export default defineMessages({
  copy: {
    id: "copyToClipboardIcon.copy",
    defaultMessage: "Copy",
  },
  copied: {
    id: "copyToClipboardIcon.copied",
    defaultMessage: "Copied",
  },
});
